<div class="auto-group-sources-container">
  <div class="auto-group-sources-label">{{'new_group_settings.auto_group_sources.label' | translate}}</div>
  <auto-group-source-item *ngFor="let item of autoGroupSource;index as itemIndex"
                          [influencerGroupId]="influencerGroupId"
                          [availableAutoGroupSourceList]="availableAutoGroupSourceList"
                          [sourceItem]="item"
                          [itemIndex]="itemIndex"
                          [listProject]="listProject"
                          [campaignList]="campaignList"
                          [influencerGroupList]="influencerGroupList"
                          [brandedSignUpConfig]="brandedSignUpConfig"
                          (changeGroupSourceEvent)="changeGroupSourceEvent($event)"
                          (deleteGroupSourceEvent)="deleteGroupSourceEvent($event, itemIndex)"
                          (editOrCreateProjectEvent)="editOrCreateProject($event)">
  </auto-group-source-item>
  <div class="footer-bar">
    <div class="add-btn-container" *ngIf="!hideAddBtn">
      <a class="add-btn" (click)="addMoreGroupSources()">
        <img src="/assets/images/Plus_Dark.svg" >
      </a>
    </div>

    <div *ngIf="showSourceRequiredErrorMessage" class="source-required-error-container">
      <span>{{'new_group_settings.auto_group_sources.source_required_message' | translate}}</span>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-sources/auto-group-sources.component.html